
import React, { useState } from "react";
import {
  Box,
  IconButton,
  Typography,
  Button,
  Paper,
  Radio,
  Stack,
  CircularProgress,
} from "@mui/material";
import LocalHospitalIcon from "@mui/icons-material/LocalHospital";
import PaymentIcon from "@mui/icons-material/Payment";
import { useNavigate, useLocation } from "react-router-dom";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import CustomDialog from "../../CustomDialog";
import { apiRequest } from '../../fetchSetup';
import axios from 'axios';


const paymentOptions = [
  { 
    id: "online", 
    label: "Pay Online", 
    type: "online", 
    icon: <PaymentIcon sx={{ color: "#008080" }} />,
    description: "UPI, Cards, Net Banking, Wallets"
  },
  { 
    id: "offline", 
    label: "Pay at Clinic", 
    type: "offline", 
    icon: <LocalHospitalIcon sx={{ color: "#008080" }} />,
    description: "Pay during your visit"
  },
];

const PaymentMethodSelection = () => {
  const [selected, setSelected] = useState("online");
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogMessage, setDialogMessage] = useState("");

  // API endpoints
  const bookAppointmentApi = process.env.REACT_APP_BOOK_APPOINTMENT_API;
  const verifyPaymentApi = process.env.REACT_APP_PROCESS_PAYEMENT;
  const razorpaycreationApi = process.env.REACT_APP_CREATE_RAZORPAY_ORDER;
  const razorpaykeyApi = process.env.REACT_APP_RAZORPAY_KEY;

  // Get booking data from location state
  const { 
    name, 
    dob, 
    gender, 
    email,
    phone,
    selectedDate, 
    serviceTitle, 
    prescription, 
    servicePrice,
    orderType, 
    diagnosticOrderData,
    deliveryAddress,
    patientInfo,

    totalAmount, // This is the final calculated amount
    subscriptionDiscount = 0,
    promoDiscount = 0,
    appliedPromo,
    promoCode,
    subscriptionBenefits,
  } = location.state || {};

  const community=sessionStorage.getItem("community")

  // ✅ ADD THESE VARIABLE DECLARATIONS:
  const deliveryCharge =deliveryAddress.community_name !== "Honer Vivantis"
    ?  Number(process.env.REACT_APP_DELIVERY_CHARGE) || 0:0;
  const finalAmount = totalAmount || servicePrice || 0;
  
  // Calculate base amount by reversing the discounts
  const baseAmount = orderType === "diagnostic" 
    ? (diagnosticOrderData?.total_amount || servicePrice || 0)
    : (finalAmount - deliveryCharge + subscriptionDiscount + promoDiscount);




  // Validate data on mount
  React.useEffect(() => {
    // Use patientInfo fields first, then fall back to direct props
    const patientName = patientInfo?.name || name;
    const patientPhone = patientInfo?.phone || phone;
    const appointmentDate = selectedDate;
    
    if (!patientName || !appointmentDate || !servicePrice) {
      console.error(" Missing required data:", { 
        patientName, 
        appointmentDate, 
        servicePrice 
      });
      setDialogMessage("Missing booking information. Please start from the beginning.");
      setDialogOpen(true);
      setTimeout(() => navigate(-1), 2000);
      return;
    }
    
    if (orderType === 'diagnostic') {
      if (!diagnosticOrderData || !diagnosticOrderData.tests || diagnosticOrderData.tests.length === 0) {
        console.error(" Missing diagnostic data");
        setDialogMessage("Missing diagnostic test information. Please start again.");
        setDialogOpen(true);
        setTimeout(() => navigate(-1), 2000);
        return;
      }
      
      if (!deliveryAddress) {
        console.error("Missing delivery address");
        setDialogMessage("Missing delivery address. Please go back and add address.");
        setDialogOpen(true);
        setTimeout(() => navigate(-1), 2000);
        return;
      }

      if ( !patientPhone) {
        console.error(" Missing contact information");
        setDialogMessage("Missing contact information. Please go back and fill all details.");
        setDialogOpen(true);
        setTimeout(() => navigate(-1), 2000);
        return;
      }
    }
  }, [name, email, phone, selectedDate, servicePrice, orderType, diagnosticOrderData, deliveryAddress, patientInfo, navigate]);

  const loadRazorpayScript = () => {
    return new Promise((resolve) => {
      const script = document.createElement("script");
      script.src = process.env.REACT_APP_RAZORPAY_SCRIPT;
      script.onload = () => resolve(true);
      script.onerror = () => resolve(false);
      document.body.appendChild(script);
    });
  };
  const clearOrderData = () => {
    const keysToRemove = [
      'pharmacyDeliveryAddress',
      // 'pharmacyCart',
      // 'pharmacyPatientDetails',
      // 'pharmacyPrescription',
      // 'diagnosticOrderData',
      // 'selectedTests',
      // 'patientInfo'
    ];
    
    keysToRemove.forEach(key => {
      sessionStorage.removeItem(key);
      console.log(` Cleared: ${key}`);
    });
    
    console.log(' All order data cleared successfully');
  };
  const createBooking = async (paymentData) => {
    // Use patientInfo first, then fall back to direct props
    const bookingName = patientInfo?.name || name;
    const bookingEmail = patientInfo?.email || email;
    const bookingPhone = patientInfo?.phone || phone;
    const bookingGender = patientInfo?.gender || gender || "male";
    const bookingAge = patientInfo?.dob || dob;

    console.log(" Using booking details:", {
      bookingName,
      bookingEmail,
      bookingPhone,
      bookingGender,
      bookingAge
    });

    // Ensure amount is a number
    const cleanPaymentData = {
      ...paymentData,
      amount: typeof paymentData.amount === 'string' 
        ? parseFloat(paymentData.amount.toString().replace(/[^0-9.]/g, ''))
        : paymentData.amount
    };



 

const diagnosticTestsString = orderType === "diagnostic" && diagnosticOrderData?.tests
  ? diagnosticOrderData.tests.map(test => {
      const testName = test.test_name || test.name;
      const testPrice = test.non_membership || test.price || test.mrp || 0;
      const qty = test.quantity || 1;
      return qty > 1
        ? `${testName} x${qty} (₹${testPrice} each)`
        : `${testName} (₹${testPrice})`;
    }).join(", ")
  : "";
  
    // Build booking payload with ALL required fields
    const bookingPayload = {
      name: bookingName,
      email: bookingEmail,
      phone: bookingPhone,
      gender: bookingGender,
      age: bookingAge,
      service_type: serviceTitle || "DIAGNOSTIC SAMPLE COLLECTION",
      date: selectedDate,
      // notes: orderType === "diagnostic" 
      //   ? `Diagnostic tests: ${diagnosticOrderData?.tests?.map(t => t.test_name).join(', ')}. Address: ${deliveryAddress?.community_name}, ${deliveryAddress?.address_line1}, ${deliveryAddress?.city}` 
      //   : "Booked through the services page",
      diagnostic_tests: diagnosticTestsString,
      order_from:"Booked by Admin",
      notes:
        orderType === "diagnostic"
          ? `Booked By Admin`
          : "Booked through the services page",
      source: "webApp",
      payment: cleanPaymentData,
      prescription,
    };

    // Add diagnostic-specific data
    if (orderType === "diagnostic" && diagnosticOrderData) {
      bookingPayload.order_type = "diagnostic";
      bookingPayload.test_details = {
        total_amount: diagnosticOrderData.total_amount || servicePrice,
        mrp_total: diagnosticOrderData.mrp_total || servicePrice,
        savings: diagnosticOrderData.savings || 0,
        // test_count: diagnosticOrderData.tests?.length || 0,
        test_count: diagnosticOrderData.tests?.reduce((s, t) => s + (t.quantity || 1), 0) || 0,
        promo_discount: promoDiscount ||0,
        promo_code: promoCode || null,
        delivery_charge:deliveryCharge,
        appliedPromoData:appliedPromo
      };
      bookingPayload.delivery_address = deliveryAddress;
      
      // Add patient info to booking payload
      if (patientInfo) {
        bookingPayload.patient_details = {
          name: patientInfo.name,
          email: patientInfo.email,
          phone: patientInfo.phone,
          gender: patientInfo.gender,
          dob: patientInfo.dob,
        };
      }
    }

    console.log(" Creating booking with payload:", JSON.stringify(bookingPayload, null, 2));

    try {
      const res = await apiRequest(bookAppointmentApi, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(bookingPayload),
      });
      if (!res.ok) throw new Error(`Booking failed (${res.status})`);
      const result = await res.json();
      console.log("data before invoice",result)
    if (!result.booking_id) throw new Error("No booking_id returned");
    const community_name=sessionStorage.getItem('user')
    const community=JSON.parse(community_name).address.community_name
     try{
       const appointmentOrderData={
          service_type:"diagnostic",
          order_id: result.booking_id,
          items: diagnosticOrderData.tests,
          patient_details: bookingPayload,
          subtotal: result.amount,
          discount: diagnosticOrderData.savings,
          total_amount: result.amount,
          community_name:deliveryAddress.community_name,
          delivery_charge:deliveryCharge,
          payment: { method: result.payment_method },
          appliedPromo:appliedPromo,
          created_at: new Date().toISOString()
        }


            const invoice_response = await axios.post(
              `${process.env.REACT_APP_API_INVOICE}/invoice/pos_invoice`,
              appointmentOrderData,
            );
      
          const invoice = invoice_response.data.invoice_details;
          if (invoice.storage_type === "s3") {
            // Open CloudFront URL
            window.open(invoice.cloudfront_url, "_blank");
          } else if (invoice.storage_type === "local") {
            try {
            const token = sessionStorage.getItem("token");

            const response = await axios.get(
              `${process.env.REACT_APP_API_INVOICE}/diagnostic-invoice/download/${appointmentOrderData.order_id}`,
              {
                responseType: "blob",
                headers: {
                  Authorization: `Bearer ${token}`,
                },
              }
            );

            const blob = new Blob([response.data], { type: "application/pdf" });
            const url = window.URL.createObjectURL(blob);

            window.open(url, "_blank");

          } catch (error) {
            console.error("Invoice download failed:", error);
          }
          }

        }
        catch (error) {
            console.error("Invoice upload failed:", error);
          }
      
      if (!res.ok) {
        console.error(" Booking failed - Status:", res.status);
        console.error(" Booking failed - Response:", result);
        throw new Error(result.error || result.detail || "Booking failed");
      }

      console.log("Booking created successfully:", result);
      clearOrderData();
      navigate("/booking-status", {
        state: { 
          ...result, 
          name: bookingName, 
          serviceTitle: serviceTitle || "DIAGNOSTIC SAMPLE COLLECTION", 
          selectedDate,
          paymentMethod: cleanPaymentData.method,
          orderType,
          diagnosticOrderData,
          deliveryAddress,
        },
      });

    } catch (err) {
      console.error("Booking error:", err);
      throw err;
    }
  };

  const handleOfflinePayment = async () => {
    console.log(" Processing offline payment...");
    
    const paymentData = {
      payment_id: `offline_${Date.now()}`,
      // amount: servicePrice || 0,
      amount: finalAmount, // ✅ Use finalAmount
      method: "offline",
      status: "pending",
      gateway: null,
      transaction_history: [
        {
          timestamp: new Date().toISOString(),
          method: "offline",
          status: "pending",
        }
      ],
    };
  
    await createBooking(paymentData);
  };

  const handleOnlinePayment = async () => {
    const bookingName = patientInfo?.name || name;
    const bookingEmail = patientInfo?.email || email;
    const bookingPhone = patientInfo?.phone || phone;

    try {
      console.log("Starting online payment process...");

      const scriptLoaded = await loadRazorpayScript();
      if (!scriptLoaded) {
        throw new Error("Failed to load Razorpay SDK. Please check your internet connection.");
      }

    const diagnosticTestsString = orderType === "diagnostic" && diagnosticOrderData?.tests
  ? diagnosticOrderData.tests.map(test => {
      const testName = test.test_name || test.name;
      const testPrice = test.non_membership || test.price || test.mrp || 0;
      const qty = test.quantity || 1;
      return qty > 1
        ? `${testName} x${qty} (₹${testPrice} each)`
        : `${testName} (₹${testPrice})`;
    }).join(", ")
  : "";
    const bookingPayload = {
      name: bookingName,
      email: bookingEmail,
      phone: bookingPhone,
      gender: patientInfo?.gender || gender || "male",
      age:  patientInfo?.dob || dob,
      service_type: serviceTitle || "DIAGNOSTIC SAMPLE COLLECTION",
      date: selectedDate,
      // notes: orderType === "diagnostic" 
      //   ? `Diagnostic tests: ${diagnosticOrderData?.tests?.map(t => t.test_name).join(', ')}. Address: ${deliveryAddress?.community_name}, ${deliveryAddress?.address_line1}, ${deliveryAddress?.city}` 
      //   : "Booked through the services page",
      diagnostic_tests: diagnosticTestsString,
      order_from:"Booked by Admin",
      notes:
        orderType === "diagnostic"
          ? `Booked By Admin`
          : "Booked through the services page",
      source: "webApp",
      prescription,
      community:deliveryAddress.community_name,
    };

    // Add diagnostic-specific data
     if (orderType === "diagnostic" && diagnosticOrderData) {
      bookingPayload.order_type = "diagnostic";
      bookingPayload.promo_discount= promoDiscount ||0;
      bookingPayload.promo_code= promoCode || null;
      bookingPayload.test_details = {
        total_amount: diagnosticOrderData.total_amount || servicePrice,
        mrp_total: diagnosticOrderData.mrp_total || servicePrice,
        savings: diagnosticOrderData.savings || 0,
        // test_count: diagnosticOrderData.tests?.length || 0,
        test_count: diagnosticOrderData.tests?.reduce((s, t) => s + (t.quantity || 1), 0) || 0,
        delivery_charge:deliveryCharge,
        appliedPromoData:appliedPromo,
        tests:diagnosticOrderData.tests
      };
      bookingPayload.delivery_address = deliveryAddress;
      
      // Add patient info to booking payload
      if (patientInfo) {
        bookingPayload.patient_details = {
          name: patientInfo.name,
          email: patientInfo.email,
          phone: patientInfo.phone,
          gender: patientInfo.gender,
          dob: patientInfo.dob,
        };
      }
    }
      console.log(" Creating Razorpay order...");
      const orderRes = await apiRequest(razorpaycreationApi, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ 
          // amount: servicePrice,
          amount: finalAmount,
          currency: "INR",
          receipt: `receipt_${Date.now()}`,
          notes: {
            name: bookingName,
            service: serviceTitle || "DIAGNOSTIC SAMPLE COLLECTION",
            date: selectedDate,
            orderType: orderType || "diagnostic",
          },
          service_type:orderType,
          customer_name:deliveryAddress.full_name,
          contact: deliveryAddress.phone,
          booking_payload: bookingPayload,
        }),
      });

      if (!orderRes.ok) {
        const errorData = await orderRes.json();
        console.error(" Order creation failed:", errorData);
        throw new Error(errorData.error || errorData.detail || "Failed to create payment order");
      }

      const orderData = await orderRes.json();
      console.log("✅ Razorpay order created:", orderData);
      sessionStorage.setItem('currentDiagnosticOrderId',orderData.booking_id)
      sessionStorage.setItem('bookingPayload',JSON.stringify(bookingPayload))

      const options = {
        key: razorpaykeyApi,
        amount: orderData.amount,
        currency: orderData.currency,
        name: "Ayuja Services",
        description: orderType === 'diagnostic' 
          ? `Diagnostic Tests - ${diagnosticOrderData?.tests?.length || 0} tests`
          : `Appointment: ${serviceTitle}`,
        order_id: orderData.id,
        
        prefill: {
          name: bookingName,
          email: bookingEmail,
          contact: bookingPhone,
        },
        
        config: {
          display: {
            blocks: {
              banks: {
                name: "All Payment Methods",
                instruments: [
                  { method: "upi", flows: ["qr", "collect", "intent"] },
                  { method: "card" },
                  { method: "netbanking" },
                  { method: "wallet" },
                ],
              },
            },
            sequence: ["block.banks"],
            preferences: { show_default_blocks: true },
          },
        },
        
        theme: { 
          color: "#008080",
          backdrop_color: "rgba(0, 0, 0, 0.5)",
        },
        
        handler: async function (response) {
          console.log(" Payment successful! Response:", response);
          await handlePaymentSuccess(response, orderData);
        },
        
        modal: {
          ondismiss: function() {
            console.log(" Payment cancelled by user");
            setDialogMessage("Payment cancelled. Please try again when ready.");
            setDialogOpen(true);
            setLoading(false);
          },
          confirm_close: true,
          escape: true,
        },
        
        retry: {
          enabled: true,
          max_count: 3,
        },
      };

      const rzp = new window.Razorpay(options);
      rzp.open();

    } catch (err) {
      console.error(" Online payment error:", err);
      setDialogMessage(err.message || "Payment initialization failed. Please try again.");
      setDialogOpen(true);
      setLoading(false);
    }
  };

  const handlePaymentSuccess = async (razorpayResponse, orderData) => {
    try {
      console.log(" Verifying payment...", razorpayResponse);

      const verifyRes = await apiRequest(verifyPaymentApi, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          razorpay_order_id: razorpayResponse.razorpay_order_id,
          razorpay_payment_id: razorpayResponse.razorpay_payment_id,
          razorpay_signature: razorpayResponse.razorpay_signature,
          method: "online",
          amount: orderData.amount,
        }),
      });

      if (!verifyRes.ok) {
        const errorData = await verifyRes.json();
        console.error(" Verification failed:", errorData);
        throw new Error(errorData.error || errorData.detail || "Payment verification failed");
      }

      const verifyData = await verifyRes.json();
      console.log(" Verification response:", verifyData);

      if (verifyData.status !== "success") {
        throw new Error(
          verifyData.message || `Payment verification failed. Contact support with Payment ID: ${razorpayResponse.razorpay_payment_id}`
        );
      }

      console.log(" Payment verified successfully!");


const now = new Date(); 
const timestamp = now.toISOString(); // UTC time
      const paymentData = {
        payment_id: razorpayResponse.razorpay_payment_id,
        order_id: razorpayResponse.razorpay_order_id,
        method: "online",
        status: "success",
        amount: orderData.amount,
        gateway: "razorpay",
        currency: "INR",
        transaction_history: [
          {
            timestamp: timestamp, 
            method: "online",
            gateway: "razorpay",
            payment_id: razorpayResponse.razorpay_payment_id,
            order_id: razorpayResponse.razorpay_order_id,
            status: "success",
            amount:verifyData.amount
          }
        ],
      };

      console.log(" Creating booking with payment data:", paymentData);
      await createBooking(paymentData);

    } catch (err) {
      console.error(" Payment verification error:", err);
      setDialogMessage(err.message || "Payment verification failed. Please contact support.");
      setDialogOpen(true);
      setLoading(false);
    }
  };

  const handleContinue = async () => {
    if (!selected) {
      setDialogMessage("Please select a payment method");
      setDialogOpen(true);
      return;
    }

    setLoading(true);

    try {
      if (selected === "offline") {
        await handleOfflinePayment();
      } else if (selected === "online") {
        await handleOnlinePayment();
      }
    } catch (err) {
      console.error("Error in handleContinue:", err);
      setDialogMessage("An error occurred. Please try again.");
      setDialogOpen(true);
      setLoading(false);
    }
  };



  

  // Get display values with fallbacks
  const displayName = patientInfo?.name || name;
  const displayEmail = patientInfo?.email || email;
  const displayPhone = patientInfo?.phone || phone;

  return (
    <>
      <Box
        sx={{
          p: 4,
          maxWidth: 600,
          mx: "auto",
          backgroundColor: "#fff",
          mt: 2,
          border: "2px solid #008080",
          borderRadius: 2,
        }}
      >
        <IconButton onClick={() => navigate(-1)} disabled={loading}>
          <ArrowBackIosNewIcon />
        </IconButton>

        <Typography
          variant="h5"
          sx={{ mb: 2, color: "#004d4d", fontWeight: 700 }}
        >
          PAYMENT METHOD
        </Typography>

        <Typography variant="body1" sx={{ mb: 3, color: "#555" }}>
          Choose how you'd like to pay
        </Typography>

        <Paper 
          sx={{ 
            p: 2, 
            mb: 3, 
            backgroundColor: "#f5f5f5",
            borderLeft: "4px solid #008080" 
          }}
        >
          <Typography variant="subtitle2" color="textSecondary" gutterBottom>
            Booking Summary
          </Typography>
          
          <Typography variant="body2" sx={{ mt: 1 }}>
            <strong>Patient:</strong> {displayName}
          </Typography>
          
          <Typography variant="body2">
            <strong>Email:</strong> {displayEmail}
          </Typography>
          
          <Typography variant="body2">
            <strong>Phone:</strong> {displayPhone}
          </Typography>

          <Typography variant="body2" sx={{ mt: 1 }}>
            <strong>Service:</strong> {serviceTitle || "DIAGNOSTIC SAMPLE COLLECTION"}
          </Typography>

          {orderType === "diagnostic" && diagnosticOrderData?.tests && (
            <Box sx={{ mt: 1, mb: 1 }}>

              <Typography variant="body2" sx={{ fontWeight: 600 }}>
                  Selected Tests ({diagnosticOrderData.tests.reduce((s, t) => s + (t.quantity || 1), 0)}):
                </Typography>


              {diagnosticOrderData.tests.slice(0, 3).map((test, index) => {
                  const testName = test.test_name || test.name;
                  const testPrice = test.non_membership || test.price || test.mrp || 0;
                  const mrpPrice = test.mrp || 0;
                  const qty = test.quantity || 1;

                  return (
                    <Typography key={index} variant="caption" display="block" sx={{ ml: 1 }}>
                      • {testName} {qty > 1 && <strong>x{qty}</strong>} -{" "}
                      <strong>₹{testPrice}</strong>
                      {qty > 1 && <span style={{ color: "#666" }}> each</span>}
                      {mrpPrice > 0 && mrpPrice > testPrice && (
                        <span style={{ textDecoration: "line-through", color: "#9CA3AF", marginLeft: "4px" }}>
                          ₹{mrpPrice}
                        </span>
                      )}
                      {qty > 1 && (
                        <span style={{ marginLeft: "4px", fontWeight: 600 }}>
                          = ₹{(testPrice * qty).toFixed(2)}
                        </span>
                      )}
                    </Typography>
                  );
                })}
              {diagnosticOrderData.tests.length > 3 && (
                <Typography variant="caption" display="block" sx={{ ml: 1, fontStyle: 'italic' }}>
                  + {diagnosticOrderData.tests.length - 3} more tests
                </Typography>
              )}
              {diagnosticOrderData.savings > 0 && (
                <Typography variant="caption" color="success.main" sx={{ ml: 1, display: 'block', mt: 0.5 }}>
                  You save: ₹{diagnosticOrderData.savings.toFixed(2)}
                </Typography>
              )}
            </Box>
          )}

          <Typography variant="body2">
            <strong>Date:</strong> {selectedDate ? new Date(selectedDate).toLocaleString() : 'N/A'}
          </Typography>
          
          {deliveryAddress && (
            <Typography variant="body2" sx={{ mt: 1 }}>
              <strong>Address:</strong> {deliveryAddress.community_name}, {deliveryAddress.address_line1}
            </Typography>
          )}

          {/* ✅ Price Breakdown Section */}
          <Box sx={{ mt: 2, pt: 2, borderTop: '1px solid #ddd' }}>
            <Typography variant="body2" sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
              <span>Subtotal:</span>
              <span>₹{baseAmount.toFixed(2)}</span>
            </Typography>

            {deliveryCharge > 0 && (
              <Typography variant="body2" sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
                <span>Delivery Charge:</span>
                <span>₹{deliveryCharge.toFixed(2)}</span>
              </Typography>
            )}

            {subscriptionDiscount > 0 && subscriptionBenefits && (
              <Typography 
                variant="body2" 
                sx={{ 
                  display: 'flex', 
                  justifyContent: 'space-between', 
                  mb: 0.5,
                  color: '#8B5CF6' 
                }}
              >
                <span>
                  Subscription Discount ({subscriptionBenefits.benefits?.medicine_discount || 0}%)
                  <Typography variant="caption" display="block" sx={{ color: '#9CA3AF', fontSize: '10px' }}>
                    {subscriptionBenefits.subscription?.name}
                  </Typography>
                </span>
                <span>-₹{subscriptionDiscount.toFixed(2)}</span>
              </Typography>
            )}

            {promoDiscount > 0 && appliedPromo && (
              <Typography 
                variant="body2" 
                sx={{ 
                  display: 'flex', 
                  justifyContent: 'space-between', 
                  mb: 0.5,
                  color: '#10B981' 
                }}
              >
                <span>Promo Discount ({appliedPromo.code})</span>
                <span>-₹{promoDiscount.toFixed(2)}</span>
              </Typography>
            )}

            <Box sx={{ mt: 1, pt: 1, borderTop: '2px solid #008080' }}>
              <Typography 
                variant="body2" 
                sx={{ 
                  display: 'flex', 
                  justifyContent: 'space-between',
                  fontWeight: 700,
                  fontSize: '16px',
                  color: "#008080"
                }}
              >
                <span>Total Amount:</span>
                <span>₹{finalAmount.toFixed(2)}</span>
              </Typography>
            </Box>
          </Box>
        </Paper>
        <Stack spacing={2}>
          {paymentOptions.map((option) => {
            const isSelected = selected === option.id;
            return (
              <Paper
                key={option.id}
                variant="outlined"
                onClick={() => !loading && setSelected(option.id)}
                sx={{
                  p: 2,
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  borderColor: isSelected ? "#008080" : "#ccc",
                  backgroundColor: isSelected ? "#E6F7F7" : "#fff",
                  cursor: loading ? "not-allowed" : "pointer",
                  opacity: loading ? 0.6 : 1,
                  transition: "all 0.2s",
                  "&:hover": {
                    borderColor: loading ? "#ccc" : "#008080",
                    backgroundColor: loading ? (isSelected ? "#E6F7F7" : "#fff") : "#E6F7F7",
                  }
                }}
              >
                <Stack direction="row" spacing={2} alignItems="center">
                  {option.icon}
                  <Box>
                    <Typography fontWeight={isSelected ? 600 : 400}>
                      {option.label}
                    </Typography>
                    <Typography variant="caption" color="textSecondary">
                      {option.description}
                    </Typography>
                  </Box>
                </Stack>
                <Radio
                  checked={isSelected}
                  value={option.id}
                  disabled={loading}
                  onChange={() => setSelected(option.id)}
                  sx={{
                    color: "#008080",
                    "&.Mui-checked": { color: "#008080" },
                  }}
                />
              </Paper>
            );
          })}
        </Stack>

        <Box display="flex" justifyContent="center" mt={4}>
          <Button
            variant="contained"
            sx={{
              backgroundColor: "#008080",
              "&:hover": { backgroundColor: "#006666" },
              px: 4,
              minWidth: 200,
            }}
            onClick={handleContinue}
            disabled={loading}
          >
            {loading ? (
              <>
                <CircularProgress size={24} sx={{ color: "#fff", mr: 1 }} />
                Processing...
              </>
            ) : (
              "Proceed to Pay"
            )}
          </Button>
        </Box>
      </Box>

      <CustomDialog
        open={dialogOpen}
        message={dialogMessage}
        onClose={() => setDialogOpen(false)}
      />


    </>
  );
};

export default PaymentMethodSelection;